/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HistoricalTrainingInputResponse } from '../../models/historical-training-input-response';

export interface GetHistoricalTrainingInputData$Params {
  location_id: string;
  from?: string;
  to?: string;
  weatherDataSource?: string;
}

export function getHistoricalTrainingInputData(http: HttpClient, rootUrl: string, params: GetHistoricalTrainingInputData$Params, context?: HttpContext): Observable<StrictHttpResponse<HistoricalTrainingInputResponse>> {
  const rb = new RequestBuilder(rootUrl, getHistoricalTrainingInputData.PATH, 'get');
  if (params) {
    rb.path('location_id', params.location_id, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('weatherDataSource', params.weatherDataSource, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HistoricalTrainingInputResponse>;
    })
  );
}

getHistoricalTrainingInputData.PATH = '/locations/{location_id}/forecast-input/historical-training';
